import { CevopBrand } from '@cevop/ui';
import { Link } from 'react-router-dom';

const cols = [
  {
    title: 'Product',
    links: [
      { label: 'Business', href: '/business' },
      { label: 'POS', href: '/pos' },
      { label: 'Stock', href: '/business#stock' },
      { label: 'Buying', href: '/business#buying' },
      { label: 'Money', href: '/business#money' },
      { label: 'Pricing', href: '/pricing' },
      { label: 'Billing', href: '/billing' },
    ],
  },
  {
    title: 'Solutions',
    links: [
      { label: 'Small business', href: '/solutions#small' },
      { label: 'Growing business', href: '/solutions#growing' },
      { label: 'Multi-location', href: '/solutions#multi' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Help centre', href: '/help' },
      { label: 'FAQ', href: '/faq' },
      { label: 'Journal', href: '/blog' },
      { label: 'Guides', href: '/guides' },
      { label: 'Getting started', href: '/help/getting-started' },
      { label: 'Security', href: '/security' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', href: '/about' },
      { label: 'How it is used', href: '/stories' },
      { label: 'Contact', href: '/contact' },
      { label: 'Privacy', href: '/privacy' },
      { label: 'Terms', href: '/terms' },
    ],
  },
];

export function SiteFooter() {
  return (
    <footer className="bg-inverse text-inverse-fg">
      <div className="mx-auto max-w-[1280px] px-6 py-14 lg:px-10">
        <div className="grid grid-cols-2 gap-8 border-b border-inverse-fg/10 pb-10 md:grid-cols-6">
          <div className="col-span-2">
            <Link to="/" className="mb-3 inline-flex [--ink:var(--mk-inverse-fg)]" aria-label="cevop home">
              <CevopBrand wordmarkHeight={16} />
            </Link>
            <p className="mt-3 max-w-[220px] text-[0.82rem] leading-relaxed text-inverse-fg/40">
              Run your business from one connected system.
            </p>
            <p className="mt-4 text-[0.72rem] text-inverse-fg/25">Built for Nigerian businesses.</p>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <div className="mb-3 text-[0.68rem] font-semibold tracking-widest text-inverse-fg/35 uppercase">{col.title}</div>
              <div className="space-y-2.5">
                {col.links.map((link) => (
                  <div key={link.label}>
                    <Link
                      to={link.href}
                      className="text-[0.82rem] text-inverse-fg/55 transition-colors duration-150 hover:text-inverse-fg"
                    >
                      {link.label}
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col items-start justify-between gap-3 pt-6 sm:flex-row sm:items-center">
          <p className="text-[0.72rem] text-inverse-fg/25">© {new Date().getFullYear()} cevop. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-[0.72rem] text-inverse-fg/30 transition-colors hover:text-inverse-fg/60">
              Privacy
            </Link>
            <Link to="/terms" className="text-[0.72rem] text-inverse-fg/30 transition-colors hover:text-inverse-fg/60">
              Terms
            </Link>
            <Link to="/contact" className="text-[0.72rem] text-inverse-fg/30 transition-colors hover:text-inverse-fg/60">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
